import { Box, Flex } from 'reflexbox';
import styled, { ThemeProvider } from 'styled-components';

import { useKeychain } from '@treams/auth';
import {
	Container,
	Paragraph,
	Sidebar,
	SidebarLayout,
	Skeleton,
	Spinner,
	Title,
} from '@treams/treams-ui';

import Menu from 'navigation/Menu';
import { Background, Element } from 'packages/kakapo-ui-kit/components/forms/layouts/PublicForm';
import treams from 'packages/kakapo-ui-kit/themes/treams';

const Ribbon = styled(Box)`
	background: ${(props) => props.theme.colors.slateBlue};
	height: 2px;
`;

export default function FullPageLoadingContainer() {
	const keychain = useKeychain();

	if (keychain.all().length === 0) {
		return (
			<ThemeProvider theme={treams}>
				<Background>
					<Element>
						<Flex alignItems="center" justifyContent="center">
							<Spinner />
						</Flex>
					</Element>
				</Background>
			</ThemeProvider>
		);
	}

	return (
		<Flex height="100vw" flexDirection="column">
			<SidebarLayout
				sidebar={
					<Sidebar>
						<Box mb={3}>
							<Skeleton.Box width={140} height={50} />
						</Box>
						<Skeleton.Repeat count={3}>
							<Sidebar.Item.Skeleton />
						</Skeleton.Repeat>
					</Sidebar>
				}
			>
				<Ribbon />
				<Menu.Skeleton />
				<Container py={4}>
					<Title.Skeleton width={200} mb={3} />
					<Paragraph.Skeleton width={300} mb={3} lines={5} />
					<Paragraph.Skeleton width={240} mb={3} lines={3} />
					<Paragraph.Skeleton width={320} mb={3} lines={4} />
				</Container>
			</SidebarLayout>
		</Flex>
	);
}
